import ProblemCards from "./ProblemCards";

const Header = () => {
  return (
    <div className="pt-6 md:pt-10 mb-8 md:mb-16 max-w-5xl mx-auto">
      <h1 className="font-medium text-center mb-12 md:mb-24 md:text-5xl lg:text-7xl px-4 md:px-0 text-2xl">
        I problemi moderni HR
      </h1>
      
      <ProblemCards />
    </div>
  );
};

export default Header;